import { FaShare } from 'react-icons/fa';
import './TopBar.css';

const TopBar = ({ 
  showTopBar, 
  showShare, 
  onShare
}) => {
  if (!showTopBar) return null;

  return (
    <div className="profile-topbar">
      <div className="topbar-buttons-group">
        {showShare && (
          <button 
            className="topbar-button" 
            onClick={onShare}
            aria-label="Compartir"
          >
            <FaShare />
          </button>
        )}
      </div>
    </div>
  );
};

export default TopBar;

